// src/locales/en/orderAssignment.js
export const orderAssignment = {
  specialNote: 'Special note',
  // Page titles
  configurationTitle: 'Assignment Rules Configuration',
  configurationSubtitle: 'Configure automatic order assignment rules',
  manualAssignmentTitle: 'Manual Order Assignment',
  manualAssignmentSubtitle: 'Bulk assign orders to team members',
  myWorkQueue: 'My Work Queue',
  workQueueSubtitle: 'Manage your assigned orders',

  // Shop selection
  shopSelection: 'Shop Selection',
  selectShop: 'Select Shop',
  selectShopPlaceholder: 'Select a shop',
  shopName: '{{name}} ({{type}})',

  // Auto-assignment status
  autoAssignmentStatus: 'Auto-Assignment Status',
  autoAssignmentEnabled: 'Auto-Assignment is Enabled',
  autoAssignmentDisabled: 'Auto-Assignment is Disabled',
  enabledDescription: 'New orders will be automatically assigned based on the rules below',
  disabledDescription: 'Enable to automatically assign new orders to team members',

  // Grand total rules
  grandTotalRules: 'Grand Total Rules',
  grandTotalRulesInfo: "Assign orders to specific users based on the order's grand total amount. Rules are processed in order.",
  addRule: 'Add Rule',
  deleteRule: 'Delete Rule',
  ruleNumber: 'Rule #{{number}}',
  minimumAmount: 'Minimum Amount',
  maximumAmount: 'Maximum Amount',
  noMinimum: 'No minimum',
  noMaximum: 'No maximum',
  assignTo: 'Assign To',
  selectUsers: 'Select users...',
  searchUsers: 'Search users...',
  rangePreview: 'Range: {{min}} - {{max}}',
  rangePreviewCurrency: 'Range: {{min}} - {{max}}',
  rangePreviewInfinity: 'Range:{{min}} - ∞',
  rangePreviewZeroToInfinity: 'Range: 0 - ∞',
  noGrandTotalRules: 'No grand total rules configured',
  addFirstRule: 'Add Your First Rule',
  to: 'to',

  // Product rules
  productRules: 'Product Rules',
  productRulesInfo: 'Assign orders to specific users when they contain certain products. Processed after grand total rules.',
  products: 'Products',
  selectProducts: 'Select products...',
  searchProducts: 'Search products...',
  noProductRules: 'No product rules configured',
  allProducts: 'All Products',

  // Default assignment
  defaultAssignment: 'Default Assignment',
  defaultAssignmentInfo: "Orders that don't match any grand total or product rules will be assigned to these users.",
  defaultAssignees: 'Default Assignees',
  selectDefaultUsers: 'Select default users...',
  defaultAssignmentNote: "Orders that don't match any rules will be assigned to these users",

  // Status filter for assignment
  statusFilter: 'Status Filter',
  statusFilterInfo: 'Only assign orders with the selected statuses. Leave empty to assign orders of all open statuses.',
  filterByStatus: 'Filter by Status',
  selectStatuses: 'Select statuses...',
  allOpenStatuses: 'All open statuses',
  statusFilterActive: 'Filtering: {{count}} status(es) selected',

  // Manual assignment specific
  assignmentConfiguration: 'Assignment Configuration',
  assignmentPreview: 'Assignment Preview',
  ordersToAssign: 'Orders to Assign',
  usersAssigned: 'Users Assigned',
  unassignedOrders: 'Unassigned Orders',
  unbalancedWarning: 'Unbalanced',
  executeAssignment: 'Execute Assignment',
  executing: 'Assigning...',
  executeAssignmentWithCount: 'Execute Assignment ({{count}} orders)',
  unassigned: 'Unassigned',
  ordersCount: '{{count}} orders',

  // Assignment stats table
  assignmentOverview: 'Current Assignment Overview',
  assignmentOverviewInfo: 'Active order assignments for this shop (open statuses only)',
  loadingStats: 'Loading assignment overview...',
  noAssignmentsYet: 'No assignments yet',
  noAssignmentsDescription: 'No orders are currently assigned for this shop',
  unassignedOrdersCount: 'Unassigned Orders',
  unassignedOrdersDescription: '{{count}} order(s) have not been assigned to any user',
  user: 'User',
  totalAssignedOrders: 'Total Assigned',
  statusBreakdownCol: 'Status Breakdown',
  selectUsersToReassign: 'Select users to reassign from',
  reassignSelected: 'Reassign Selected ({{count}})',
  reassigning: 'Reassigning...',
  noUsersSelected: 'Select at least one user to reassign from',
  refreshStats: 'Refresh',

  // Reassign modal
  reassignModalTitle: 'Reassign Orders',
  reassignModalSubtitle: 'Reassigning orders from {{count}} user(s)',
  reassignStatusFilter: 'Which statuses to reassign?',
  reassignAllStatuses: 'All statuses',
  reassignSelectedStatuses: 'Selected statuses only',
  allAttempts: 'All attempts',
  reassignCriteria: 'Assignment Criteria',
  reassignCriteriaInfo: 'Orders will be reassigned using the rules below. The same grand total and product rules apply.',
  executeReassign: 'Execute Reassign',
  executeAssignUnassigned: 'Execute Assign',
  executingAssignUnassigned: 'Assigning...',
  executingReassign: 'Reassigning...',
  reassignSuccess: 'Successfully reassigned {{count}} orders',
  reassignFailed: 'Failed to reassign orders',
  confirmReassign: 'Reassign orders from {{count}} user(s)?',
  confirmReassignWithFilter: 'Reassign {{statusCount}} status(es) from {{userCount}} user(s)?',
  assignUnassignedBtn: 'Assign',

  // Work Queue
  totalAssigned: 'Total Assigned',
  confirmedVerified: 'Confirmed & Verified',
  confirmedNotVerified: 'Confirmed & Not Verified',
  orderValue: 'Order Value',
  statusBreakdown: 'Status Breakdown',
  assignmentStats: 'Assignment Statistics',
  assignedOrders: 'Assigned Orders',
  assignmentDistribution: 'Assignment Distribution',
  loadingWorkQueue: 'Please wait while we load your assigned orders...',
  unableToLoadWorkQueue: 'Unable to Load Work Queue',
  noOrdersAssigned: 'No orders assigned',
  noOrdersAssignedDescription: "You don't have any orders assigned to you at the moment",
  noOrdersFound: 'No orders found',
  noOrdersFoundDescription: 'No orders match your search criteria',
  ordersSelected: '{{count}} order(s) selected',
  searchPlaceholder: 'Search by order number or customer name...',
  assignedUser: "Assigned User",
  allUsers: "All users",
  bulkAssignTitle: "Assign Orders",
  bulkAssignSubtitle: "Assign {{count}} selected order(s) to users",
  bulkAssignInfo: "Selected orders will be distributed in round-robin across the chosen users. Any existing assignments for these orders will be replaced.",
  bulkAssignSuccess: "{{count}} order(s) assigned successfully",
  assignOrders: "Assign",
  distributeHint: "{{orders}} order(s) will be distributed across {{users}} user(s)",

  // Table columns
  order: 'Order',
  orderNumber: 'Order Number',
  paymentMethods: 'Payment Methods',
  payments: 'Payments',
  customer: 'Customer',
  customerName: 'Customer Name',
  status: 'Status',
  total: 'Total',
  assigned: 'Assigned',
  orderStatus: 'Order Status',
  statusReason: 'Status Reason',
  allStatuses: 'All Statuses',
  allReasons: 'All Reasons',
  minGrandTotal: 'Min Grand Total',
  maxGrandTotal: 'Max Grand Total',

  // Order details
  orderDetails: 'Order Details',
  orderInformation: 'Order Information',
  orderDate: 'Order Date',
  grandTotal: 'Grand Total',
  currentStatus: 'Current Status',
  customerInformation: 'Customer Information',
  name: 'Name',
  phone: 'Phone',
  email: 'Email',
  address: 'Address',
  orderItems: 'Order Items',
  sku: 'SKU',
  orderSummary: 'Order Summary',

  // Status update
  updateStatus: 'Update Status',
  clearSelection: 'Clear Selection',
  updateOrderStatus: 'Update Order Status',
  newStatus: 'New Status',
  selectStatus: 'Select status...',
  selectReason: 'Select reason...',
  holdUntilDate: 'Hold Until Date',
  holdUntil: 'Hold until',
  updateStatusButton: 'Update Status',
  updating: 'Updating...',
  confirmStatusChange: 'Are you sure you want to mark this order as "{{status}}"?',

  // Bulk operations
  bulkUpdateStatus: 'Bulk Update Status',
  aboutToUpdateOrders: 'You are about to update {{count}} order(s)',
  bulkUpdateDescription: 'This action will update the status of all selected orders to the same value.',
  updateOrdersCount: 'Update {{count}} Orders',

  // Assignment results
  assignmentComplete: 'Assignment Complete',
  successfullyAssigned: 'Successfully assigned {{count}} orders',
  assignmentFailed: 'Failed to execute assignment',

  // Metadata
  lastUpdated: 'Last Updated: {{date}}',
  updatedBy: 'By: {{name}}',
  updatedByUser: 'By: {{name}}',
  updatedByUnknown: 'By: Unknown',
  assignedAt: 'Assigned At',
  updatedAt: 'Updated At',

  // Actions
  backToOrders: 'Back to Orders',
  saveRules: 'Save Rules',
  cancel: 'Cancel',
  saving: 'Saving...',

  // Validation errors
  atLeastOneUser: 'At least one user must be selected',
  maxMustBeGreaterThanMin: 'Maximum must be greater than minimum',
  atLeastOneProduct: 'At least one product must be selected',
  atLeastOneRuleOrDefault: 'At least one rule or default assignees must be configured',
  noOrdersAvailable: 'No orders available for assignment',
  noOrdersCanBeAssigned: 'No orders can be assigned with the current criteria',
  shopRequired: 'Shop selection is required',
  pleaseSelectStatus: 'Please select a status',
  pleaseSelectReason: 'Please select a reason for this status',
  pleaseSelectHoldDate: 'Please select a hold until date',

  // Success/Error messages
  rulesSavedSuccess: 'Assignment rules saved successfully',
  rulesSaveFailed: 'Failed to save assignment rules',
  loadingConfig: 'Loading configuration...',
  loadingConfigMessage: 'Please wait while we load the assignment rules',
  loadingAssignmentData: 'Loading assignment data...',
  loadingAssignmentMessage: 'Please wait while we load the required information',
  loadDataFailed: 'Failed to load data. Please refresh the page.',
  loadOrdersFailed: 'Failed to load orders. Please try again.',
  unsavedChanges: 'You have unsaved changes. Do you want to discard them?',
  fixValidationErrors: 'Please fix validation errors before saving',
  fixValidationBeforeExecuting: 'Please fix validation errors before executing assignment',
  confirmAssignment: 'Assign {{count}} orders?',
  confirmAssignmentWithUnassigned:
    'Assign {{assigned}} orders?\n\nWarning: {{unassigned}} orders will remain unassigned.',
  confirmAssignmentUnbalanced:
    'Assign {{assigned}} orders?\n\nWarning: {{unassigned}} orders will remain unassigned.\n\nWarning: Assignment appears unbalanced. Some users will receive significantly more orders.',
  unassignedWarning: 'Warning: {{count}} orders will remain unassigned.',
  unbalancedAssignmentWarning:
    'Warning: Assignment appears unbalanced. Some users will receive significantly more orders.',
  noChanges: 'No changes detected',
  orderStatusUpdated: 'Order status updated successfully',
  failedToUpdateStatus: 'Failed to update order status',
  bulkUpdateSuccess: 'Successfully updated {{count}} orders',
  failedToUpdateSomeOrders: 'Failed to update some orders',
  failedToUpdateOrders: 'Failed to update orders',

  // Phone numbers and previous orders
  viewPrevious: 'View Previous',
  previousOrders: 'Previous Orders',
  noPreviousOrders: 'No previous orders found for this phone number',
  callAttempts: 'Call Attempts',
  updatingOrders: 'Updating Orders...',
  progressText: 'Updated {{current}} of {{total}} orders',

  // View selector
  view: 'View',
  assignedToMe: 'Assigned to Me',
  allOrders: 'All Orders',
  notAssigned: "Not Assigned",
  assignedTo: "Assigned To",
};